<!-- *ngIf="planInfo && planInfo.treatment_amount" -->
<div class="p-0 panel-firststep--wrapper"
  style="background-color: #dce2e7;height: 100vh !important; margin-inline: auto;"
  [ngClass]="selected_plan_index >= 0 ? 'panel_start' : ''" [class.ar-new-flow]="planInfo && planInfo.ar_flow_immediate">
  <!-- style="max-height: 820px; overflow-y: auto;" -->

  <div class="panel-outer--mainwrapper" (change)="detect($event)"
    [ngClass]="planInfo.plans_array && planInfo.plans_array.length == 1?'one-plan':planInfo.plans_array && planInfo.plans_array.length==2?'two-plan':''"
    [class.file_highlights]="planInfo && planInfo.contract_type == 6 && planInfo.plans_array.length==2">
    <div class="col py-md-3 bg-white sidebar_plan_details d-sm-block d-xs-block"
      [ngClass]="{'borderBottom': stepHeader}">
      <div class="">
        <app-steps class="mt-3" (triggerChangeScreens)="goBack()"></app-steps>
      </div>

      <!-- <div class="mt-md-4 estimate-plan new-payment-plan d-md-block d-none">
        <div class="row justify-content-between estimate-plan-invoice">
          <div class="autor-name col-md-7 col-12">
            <p class="fs-18 howard fw-700 color-black mb-1">Hello&nbsp;
              <span class="fs-18 fw-700 text-capitalize howard1 text--black"><span
                  class="notranslate">{{(planInfo.patient_first_name || '') + ' '
                  + (planInfo.patient_last_name || '')}},</span></span>
            </p>
            <div class="con-number">
              <p class="name mail-side" [ngStyle]="planInfo.patient_mobile_country_code && planInfo.patient_mobile?{'border-right': '1px solid #FFBA55'}:''"
              >{{planInfo.patient_email}}</p>
              <p class="name" *ngIf="planInfo.patient_mobile_country_code && planInfo.patient_mobile">
                {{planInfo.patient_mobile_country_code}}-{{planInfo.patient_mobile}}
              </p>
            </div>
          </div>
          <div class="author-name2 estimated-plan text-start col-md-4 col-lg-3 col-12">
            <p class="rounded-pill  eta_button m-0"> 
              {{planInfo && planInfo.is_ar_contract == 1 ? "Total Outstanding Balance":"Estimated Payment Plan"}}
            </p>
            <p class="h1 fw-900" *ngIf="planInfo && planInfo.treatment_amount">
              <span translate="no">{{mainService.currency_data.display_logo}} {{planInfo && planInfo.treatment_amount ?
                (planInfo.treatment_amount - planInfo.downpayment_amount) : '0.00'}}</span>
            </p>
          </div>
        </div>
        <div class="footer-part">
          <div class="d-flex align-items-center justify-content-between flex-grow-1">
            <div class="pe-2 finance-rows"
              *ngIf="planInfo && ((planInfo.is_ar_contract == 1 || planInfo.enrollment_enabled != 1) && enrollmentFee )">
              <span class="financing-labels fw-400 finance-values text--black service-amount fs-14">
                {{((planInfo && planInfo.enrollment_enabled != 1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' :
                planInfo && planInfo.is_ar_contract == 1 ? 'Account Setup Fee:' : ''}}
                <div class="f-s-18-w-800 fw-700 text--black finance-values position-relative">
                  <span class="">
                    <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                      translate="no">{{mainService.currency_data.display_logo}}</span>
                    <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                      [innerText]="mainService.strike_enrollment_fee" translate="no"></span></span>
                  <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' "
                    class=" d-inline-block ms-2 fs-14 text--black fw-700">
                    <span class="notranslate">
                      {{mainService.currency_data.display_logo}} {{enrollmentFee ? enrollmentFee: '0'}}</span>
                  </div>
                  <div *ngIf="mainService.promotionalEnrollmentOffer" class="recurring-percent">Promo
                  </div>
                </div>
              </span>
            </div>

            <div class="pe-2" *ngIf="contract_service_record && contract_service_record.length > 0">
              <div class=" fs-14 rounded-bottom service-amount">
                <p class="text--black p-0 m-0 fw-400 fs-14">{{planInfo.is_ar_contract == 1?'Partial Payment':'Down payment'}}:</p>
                <p class="text--black fw-700 p-0 m-0 ms-2"> <span translate="no"> {{mainService.currency_data.display_logo}}
                  {{(planInfo.downpayment_amount)}}</span></p>
              </div>
            </div>

            <div class="pe-3" *ngIf="contract_service_record && contract_service_record.length > 0">
              <div class="fs-14 rounded-top service-amount pe-md-3">
                <p class="p-0 m-0"><span class="text--black p-0 m-0 me-1">Service amount:</span><span>
                    <button class="info_icon_btn service-amount-btn">
                      <img src="assets\png\Icons.png" alt="" class="info_icon">
                      <span class="tooltip_box text--black show_div custom_tool_recurring d-none">
                        <div class="d-flex justify-content-between border-bottom p-2 align-items-center"
                          *ngFor="let service of contract_service_record">
                          <p class="text--black p-0 m-0 fw-400 treatment_text fs-14" [tooltip]="service.service">
                            {{service.service}}</p>
                          <p class="text--black fw-700 p-0 m-0"><span translate="no">
                              {{mainService.currency_data.display_logo}}
                              {{service &&
                              service.price ? service.price : '0.00'}}</span></p>
                        </div>
                      </span>
                    </button>
                  </span></p>
                <p class="color-dblue fw-700 p-0 m-0"><span translate="no">{{mainService.currency_data.display_logo}}
                    {{planInfo.treatment_amount}}</span></p>
              </div>
            </div>

          </div>

        </div>
      </div> -->
      <!-- <div class="col-12 mt-2" style="position: sticky;top: 96vh;">
            <div class="w-100 text-center color-gray-light">
              <span>Powered By Denefits</span>
            </div>
          </div> -->
    </div>

    <div class="col px-3 mx-auto panel_plans bg-white pay-panel progress-main--wrapper__right position-relative"
      *ngIf="planInfo" [ngClass]="planInfo.plans_array && planInfo.plans_array.length ==1 ? 'scrollingup': ''"
      [class.deffered]="planInfo.contract_type == 6">
      <!-- <div class="col-md-12 mt-4 text-end header_close">
          <button class="px-3 py-2 border bg-white rounded-pill outline-0">
            Close
          </button>
          <app-steps closeOnly="true" profileButtons="true" buttonWhite="true"></app-steps>
        </div> -->
      <div class="col-12 block_hello_user_2" *ngIf="planInfo && planInfo.patient_first_name">
        <span class="fs-16 user-review">
          <span class=" text-capitalize howard1 ">Hello&nbsp;<b>{{(planInfo.patient_first_name || '') + ' '
              +(planInfo.patient_last_name || '') | titlecase }}</b>,</span>
          <span> please review the proposed payment plan(s) from &nbsp;</span>
          <span class="fw-600 text-capitalize color-black">{{planInfo.practice_name || (planInfo.doctor_first_name +
            '' + planInfo.doctor_last_name)}}:
          </span>
        </span>
      </div>
      <div class="d-md-none view_plan_block estimated-plan text-center mt-5">
        <p class="color-black fs-16 fw-700 mb-3"> {{planInfo && planInfo.is_ar_contract == 1 ? "Total Outstanding
          Balance":"Payment Plan Amount"}}</p>
        <p class="h3 fw-900 color-blue-black mb-0 d-flex align-items-center justify-content-center w-100 "
          (click)="planExpendvalue()" [class.overlay-new]="planExpanded">
          {{mainService.currency_data.display_logo}}{{planInfo && planInfo.treatment_amount ?
          ((planInfo.treatment_amount - planInfo.downpayment_amount) | DynamicDecimalPipe:mainService.currency_data.currency_code) : '0.00'}}
          <span class="ms-1 plan--iconwrap">
            <svg [ngClass]="planExpanded? 'planIconrote': ''" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
              viewBox="0 0 22 22" fill="none">
              <path d="M5 7.8125L11.1875 14L17.375 7.8125" stroke="#141616" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </p>

        <div [ngClass]="planExpanded? 'planPopupbody': ''" class="right_side_part_one payment-expend-data">
          <div class="right_side_part1 mb-4 text-start"
            *ngIf="planInfo && ((planInfo.is_ar_contract == 1 || planInfo.enrollment_enabled != 1) && enrollmentFee )">
            <span class="amo-plan1">
              {{((planInfo && planInfo.enrollment_enabled != 1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' :
              planInfo && planInfo.is_ar_contract == 1 ? 'Account Setup Fee:' : ''}}
            </span>

            <div class="amo-plan1-strike">
              <span class="wrong-data me-2">
                <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                  translate="no">{{mainService.currency_data.display_logo}}
                </span>
                <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                  [innerText]="mainService.strike_enrollment_fee" translate="no">
                </span>
              </span>
              <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' " class="">
                <span class="notranslate">
                  {{mainService.currency_data.display_logo}}{{enrollmentFee ? (enrollmentFee|DynamicDecimalPipe:mainService.currency_data.currency_code): '30'}}</span>
              </div>
              <div *ngIf="mainService.promotionalEnrollmentOffer" class="recurring-percent fw-800">PROMO
              </div>
            </div>
          </div>
          <div class="info_icon_btn_payment">
            <div class="payment_part">
              <div class="payment_part_down" *ngIf="contract_service_record && contract_service_record.length > 0">
                <span class="down-label">Down payment:</span>
                <span class="down-amo"><span translate="no">
                    {{mainService.currency_data.display_logo}}{{(planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code)}}</span></span>
              </div>
              <div class="payment_part_down" *ngIf="contract_service_record && contract_service_record.length > 0">
                <span class="down-label">Service amount:</span>
                <span class="down-amo"><span
                    translate="no">{{mainService.currency_data.display_logo}}{{planInfo.treatment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                </span>
              </div>
              <div class="service-record-wrapper ">
                <div *ngFor="let service of contract_service_record" class="payment_part_down">
                  <span class="down-label">
                    {{service.service}}</span>
                  <span class="down-amo"><span translate="no"> {{mainService.currency_data.display_logo}}{{service &&
                      service.price ? (service.price|DynamicDecimalPipe:mainService.currency_data.currency_code) : '0.00'}}</span></span>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- <div class="cost_plan">
            <button class="button-login border-0" (click)="confirmPaymentDetailsModal.show()">View Full Plan</button>
          </div> -->
      </div>

      <div class="col-12 block_hello_user_1 d-md-flex d-none " *ngIf="planInfo && planInfo.patient_first_name">
        <span class="fs-18 howard d-md-none d-block">Hello
          <span class=" text-capitalize howard1 ">{{(planInfo.patient_first_name || '') + ' ' +
            (planInfo.patient_last_name || '') | titlecase }},</span>
        </span>
        <div class="w-100 d-md-flex d-none align-items-center justify-content-between my-2 plan-available">
          <span class="fs-16 user-review">

            <span class=" text-capitalize howard1 ">Hello&nbsp;<b>{{(planInfo.patient_first_name || '') + ' '
                +(planInfo.patient_last_name || '') | titlecase }}</b>,</span>
            <span> please review the proposed payment plan(s) from&nbsp;</span>
            <span class="fw-600 text-capitalize color-black">{{planInfo.practice_name || (planInfo.doctor_first_name +
              '' + planInfo.doctor_last_name)}}:
            </span>
          </span>

          <div
            class="d-md-flex d-none pt-3 pt-md-0 color-black ms-md-auto align-items-center justify-content-between position-relative"
            *ngIf="planInfo.is_ar_contract != 1">
            <!-- <div class="pe-3">{{planInfo && planInfo.plans_array && planInfo.plans_array.length}} Plans available</div> -->
            <div class="ms-md-auto grid-span">
              <span class="ps-2" [ngClass]="[!show_all_plans ? '' : 'd-none']" role="button"><img
                  src="assets/svg/element-equal-inActive.svg" alt="" srcset=""></span>
              <span class="ps-2 collpse" (click)="show_all_plans = false;" [ngClass]="[show_all_plans ? '' : 'd-none']"
                role="button"><img src="assets/svg/element-equal.svg" alt="" srcset=""></span>
              <span class="ps-2 pe-3 expand-span" (click)="show_all_plans = true;"
                [ngClass]="[!show_all_plans ? '' : 'd-none']" role="button"><img
                  src="assets/svg/row-vertical-active.svg" alt="" srcset=""></span>
              <span class="ps-2" [ngClass]="[show_all_plans ? '' : 'd-none']" role="button"><img
                  src="assets/svg/row-vertical.svg" alt="" srcset=""></span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="top_container">
        <p class="m-0 p-0 fs-14 fw-700 grey text-white para_class ">Unlock Benefits:</p>
        <marquee behavior="scroll" direction="left" scrollamount="5" class="markque_class">

          <div class="d-flex justify-content-between">
            <div>
              <img src="\assets\png\Card.png" alt="">
              <p class="d-inline-block align-middle mb-0 p-0">No Credit Checks </p>
            </div>
            <div>
              <img src="\assets\png\Ticket Sale.png" alt="">
              <p class="d-inline-block align-middle mb-0 p-0">Improve Credit Scores </p>
            </div>
            <div>
              <img src="\assets\png\Graph Up.png" alt="">
              <p class="d-inline-block align-middle mb-0 p-0">No Prepayment Penalties </p>
            </div>
            <div>
              <img src="\assets\png\Ticket Sale.png" alt="">
              <p class="d-inline-block align-middle mb-0 p-0">No Accrued Interest on Late Payments </p>
            </div>
            <div>
              <img src="\assets\png\Bill Check.png" alt="">
              <p class="d-inline-block align-middle mb-0 p-0">Social Payments</p>
            </div>


          </div>

        </marquee>
      </div> -->

      <!-- <div class="col-12 d-none block_hello_user_2" *ngIf="planInfo && planInfo.patient_first_name">
        <div class="w-100 d-flex align-items-center justify-content-between px-1 mt-2">
          <span class="color-gray">{{planInfo && planInfo.plans_array && planInfo.plans_array.length}} Plan{{planInfo
            &&
            planInfo.plans_array && planInfo.plans_array.length > 1 && '(s)'}} available
          </span>

          <span class="toggle_block">

            <span class="px-1" [ngClass]="[!show_all_plans ? '' : 'd-none']" role="button"><img
                src="assets/svg/element-equal-inActive.svg" alt="" srcset=""></span>
            <span class="px-1" (click)="show_all_plans = false;" [ngClass]="[show_all_plans ? '' : 'd-none']"
              tooltip="collapse" role="button"><img src="assets/svg/element-equal.svg" alt="" srcset=""></span>
            <span class="px-1" (click)="show_all_plans = true;" [ngClass]="[!show_all_plans ? '' : 'd-none']"
              tooltip="expand" role="button"><img src="assets/svg/row-vertical-active.svg" alt="" srcset=""></span>
            <span class="px-1 ms-1" [ngClass]="[show_all_plans ? '' : 'd-none']" role="button"><img
                src="assets/svg/row-vertical.svg" alt="" srcset=""></span>
          </span>
        </div>
      </div> -->

      <div class="col-12 mt-3 fist-step--bodycontent"
        [ngClass]="planInfo.plans_array && planInfo.plans_array.length >= 4 ? 'shortheight' : ''">


        <div class="plan-scroll-container px-md-0 px-lg-0 p-md-0" [class.deffed__wrapper]="planInfo.contract_type == 6">
          <ng-container *ngFor="let plan of planInfo.plans_array; let i = index;">
            <div (click)="selected_plan_index  = i; continueButton = true"
              class="form-check content_mid -change_hover mb-2"
              [ngClass]="[ ((selected_plan_index == i && show_all_plans && planInfo.contract_type != 6 && planInfo.contract_type != 5) || (selected_plan_index == i && planInfo.contract_type != 6 && planInfo.contract_type != 5)) ? 'selected1' :  ((selected_plan_index == i && show_all_plans && planInfo.contract_type == 6 ) || (selected_plan_index == i && planInfo.contract_type == 6) || (show_all_plans && planInfo.contract_type == 6 )) ? 'selected2' :(planInfo.contract_type == 6) ? 'display_full_content_def': (show_all_plans && planInfo.contract_type != 6) ? 'display_full_content' : planInfo.is_ar_contract != 1 ? 'change_hover' :'change_hover_ar']"
              [class.select_ar]="selected_plan_index == i && planInfo.is_ar_contract == 1"
              [ngStyle]="planInfo && planInfo.plans_array.length == 1?{'margin-bottom': '35px'}:''"
              [class.defaultActive]="planInfo.plans_array.length == 1 &&  planInfo.contract_type == 6 "
              [class.change_hover_v2]="planInfo.contract_type == 1 || planInfo.contract_type == 3 || plan && planInfo.contract_type == 6"
              [class.keepify--box]="planInfo.contract_type == 3" [id]="'plan_month_'+''+i">
              <div class="payment_data align-items-md-center align-items-start">
                <span class="d-none pe-2 radio_content">
                  <input type="radio" name="" id="" [checked]="selected_plan_index == i">
                </span>
                <div class="plan_values w-100 d-flex align-items-center justify-content-between">
                  <div class="plan_values-month" [ngClass]="planInfo.is_ar_contract == 1 ? 'ar_phone' : ''">
                    <input type="radio" [id]="i" name="fav_language" value="select" class="input-radio"
                      [checked]="selected_plan_index == i">
                    <span
                      class="d-sm-flex align-items-center flex-grow-1 py-md-2 mb-sm-0 mb-md-0 justify-content-sm-between justify-content-center fs-20 ps-md-3 -ps-1"
                      [ngStyle]="planInfo && planInfo.contract_type != 6 ? {'border-right': '1px dashed #DBDEE1;'}:''">
                      <h5 class="mb-0 fw-900 color-blue-black fs-20 monthly-fixed text-sm-start text-center"
                        [id]="'plan_months_'+''+i">{{plan.month}} Months</h5>
                      <!-- <hr class="border_added monthly-fixed"> -->
                    </span>
                  </div>
                  <!-- </div> -->
                  <!-- <div class="plan_total_payable"> -->
                  <div
                    class="d-flex align-items-center py-md-2 py-0 justify-content-end ps-md-3 total_payable_today system-payble"
                    [class.hover-invisible]="selected_plan_index == i && planInfo.contract_type == 6">
                    <span class="monthly-fixed monthly-rate color-black">
                      <span class="notranslate listing-dollar--price">
                        {{mainService.currency_data.display_logo}}
                        {{(creditReportOption? plan.recurring_amount_with_credit_fee:plan.recurring_amount) | DynamicDecimalPipe:mainService.currency_data.currency_code}}
                        <!-- {{plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}} -->
                      </span>
                    </span>
                    <span class="ms-0 fs-16 listing-dollar--durataion">monthly
                      <!-- <span *ngIf="planInfo.is_ar_contract == 1" class="ar_view">
                        <img src="assets\png\Icons.png" alt="">
                        <div class="tool_ar position-absolute">
                          <div class="d-flex align-items-center pb-md-0 pb-2">
                            <div class="listing-body-value text-nowrap pr-1">Transaction Fee:</div>
                            <span *ngIf="mainService.getTransactionFee(planInfo,plan.recurring_amount)"
                              class="title-value font-15 text-colr position-relative listing-body-value font-weight-bold">
                              <span *ngIf="mainService.promotionalTransactionOffer"
                                class="strike_through_class fs-16 fw-600">
                                <span class="notranslate">
                                  {{mainService.getTransactionFeeStrike(planInfo,plan.recurring_amount,1)}}</span></span>
                              <img *ngIf="planInfo && planInfo.contract_type == 6 && showTransactionTip"
                                src="assets\png\Icons.png" alt="" class="info_icon px-1"
                                [tooltip]="'Transaction fee will be '+ transactionFee1 +'/payment if recurring amount is lesser to $'+planInfo.threshold_amount +'.
                                            Transaction fee will be '+ transactionFee2 +'/payment if recurring amount is greater than or equal to $' +planInfo.threshold_amount + '.'">

                              <div [ngClass]="mainService.promotionalTransactionOffer ? '' : ''"
                                class="d-inline-block ms-2">
                                <span class="text--black fs-15 fw-600">
                                  <span class="notranslate">
                                    {{(mainService.getTransactionFee(planInfo,plan.recurring_amount,1) == '$0' ||
                                    mainService.getTransactionFee(planInfo,plan.recurring_amount,1) == '0%') ?
                                    mainService.getTransactionFee(planInfo,plan.recurring_amount,1) :
                                    mainService.getTransactionFee(planInfo,plan.recurring_amount,1) +
                                    '/payment'}}</span>
                                </span>
                                <div *ngIf="mainService.promotionalTransactionOffer" class="recurring-percent">
                                  Promo
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </span> -->
                    </span>
                    <!-- </span> -->
                  </div>
                  <div *ngIf="planInfo.is_ar_contract == 1" class="ar_payable">
                    <div class="d-flex align-items-center">
                      <span class=" mb-0 fs-16 monthly-fixed text-sm-start-text-center">
                        <span class="listing-body-value fw-400 d-inline-block ">Total Payable Today:</span>
                        <span>
                          <span class="listing-body-value fw-600 text--black"> &nbsp;&nbsp;
                            <span translate="no">{{mainService.currency_data.display_logo}}{{
                             ((creditReportOption) ?  plan.to_pay_today_display : plan.to_pay_today) |DynamicDecimalPipe:mainService.currency_data.currency_code}}
                            </span></span>
                          <span class="info_icon_btn" *ngIf="plan.to_pay_today > 0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                              fill="none">
                              <path
                                d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                                stroke="#646C70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M9.375 9.375H10V13.75H10.625" stroke="#646C70" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                                fill="#646C70" />
                            </svg>
                            <span class="color-gray-1 show_div custom_tool_recurring d-none"
                              [ngClass]="planInfo && planInfo.is_ar_contract ==1 ? 'ar_contract':'tooltip_box' ">
                              <div
                                class="d-flex justify-content-between border-bottom p-2 align-items-center ng-star-inserted">
                                <span class="text--black" *ngIf="planInfo && (planInfo.ar_flow_immediate && (planInfo.downpayment_amount > 0) && planInfo.is_ar_contract) || !planInfo.ar_flow_immediate">{{'This includes the'+ (planInfo.is_ar_contract == 1 ? '' :'
                                  Down Payment,') +
                                  (plan.advance_interest_amount ?
                                  (planInfo.contract_type == 1 || planInfo.contract_type == 3 ? 'First Recurring
                                  Payment, ':
                                  (planInfo.is_ar_contract == 1 ? ' Upfront Payment, ' :' Upfront Fee, ')) : '') +
                                  (planInfo.is_ar_contract == 1 ? '' :'Enrollment Fee,') +
                                  (planInfo.is_ar_contract == 1 && planInfo.downpayment_amount > 0 ? ' Partial Payments,
                                  ' : '') +
                                  'Transaction Fee and Credee Reporting Fee if any'}}</span>
                                  <span class="text--black" *ngIf="planInfo && (planInfo.ar_flow_immediate && (planInfo.downpayment_amount == 0) && planInfo.is_ar_contract)">This include transaction fees and first recurring payment and credit reporting fee if any
                                  </span>
                              </div>
                            </span>
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <hr> -->
              <div class="defInterst flex-wrap pt-3" *ngIf="plan && planInfo.contract_type == 6">
                <div class="row">
                  <div class="col-xl-6 flex-grow-1 py-md-2 pt-2 pb-md-3 pb-2 def-border">
                    <div class="def-months-text flex-grow-1 d-flex align-items-center">
                      <span class="def-duration d-flex flex-md-nowrap flex-wrap">
                        <span class="text-nowrap months d-md-inline d-block w-100 text-start">{{plan.month >
                          planInfo.di_start_month ? 'First'
                          : ''}}
                          {{plan.month < planInfo.di_start_month ? plan.month : planInfo.di_start_month}} months:</span>
                            <span class="color-dblue px-md-3 d-md-none d-block text-nowrap">
                              <span class="notranslate"> {{mainService.currency_data.display_logo}}
                                {{plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                              <span>/month</span></span>
                        </span>
                        <span
                          class="ms-md-0 ms-auto plan_card_value fs-14 px-md-2 mt-md-0 mt-2 d-flex align-items-center">
                          <span class="color-dblue px-2 py-2 text-nowrap interest-bg"> No Interest</span>
                          <span class="color-dblue px-2 text-nowrap d-md-inline-block d-none recurring-part">
                            <span class="notranslate"> {{mainService.currency_data.display_logo}}
                              {{plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                            <span>/month</span>
                          </span>
                        </span>
                    </div>
                  </div>

                  <div class="col-xl-6 flex-grow-1 py-2">
                    <!-- <div class="" *ngif="plan && plan.next_recurring_amount != 0.00"> -->
                    <div class="def-months-text flex-grow-1 d-flex align-items-center justify-content-xl-end">
                      <span class="def-duration d-flex flex-md-nowrap flex-wrap"
                        *ngIf="plan.month > planInfo.di_start_month">
                        <span class="text-nowrap months d-md-inline d-block w-100 text-start">Remaining months: </span>
                        <span class="color-dblue px-md-3 d-md-none d-block text-nowrap">
                          <span class="notranslate"> {{mainService.currency_data.display_logo}}
                            {{plan.next_recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                          <span>/month</span>
                        </span>
                      </span>
                      <span class="ms-md-0 ms-auto plan_card_value fs-14 px-md-2 mt-md-0 mt-2 d-flex align-items-center"
                        *ngIf="plan.month > planInfo.di_start_month">
                        <span
                          class="color-dblue px-2 py-2 text-nowrap no-interest-bg d-md-inline align-items-center remaining__innerwrap">
                          Interest :
                          <span class="d-md-inline"><span class="notranslate">{{plan.interest_rate_to_show}}%
                              <sup>{{plan.interest_rate_type}}</sup></span></span>
                        </span>
                        <span class="color-dblue px-2 text-nowrap d-md-inline-block d-none">
                          <span class="notranslate">{{mainService.currency_data.display_logo}}
                            {{plan.next_recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                          <span>/month</span>
                        </span>
                      </span>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>

              <div class="listing-boddy--contentwrapper" *ngIf="plan"
                [class.forar_remove]="planInfo.is_ar_contract == 1"
                [ngClass]="{keepthree: planInfo.contract_type == 1 || planInfo.contract_type == 3 || plan && planInfo.contract_type == 6}">
                <div class="pb-md-0 pb-2" [class.keepify--padding]="planInfo.contract_type == 3"
                  *ngIf="planInfo && planInfo.contract_type != 5 || (plan && plan.interest_rate_to_show > 0 || plan.interest_rate > 0)">
                  <div class="similar" *ngIf="planInfo && planInfo.contract_type != 6">
                    <span class="listing-body-value">Interest Rate:</span>
                    <span class="plan_card_value fs-14 d-inline-block -d-block ms-md-2">
                      <span class="listing-body-value font-weight-bold"><span class="notranslate">{{plan &&
                          plan.interest_rate_to_show|| plan.interest_rate}}%
                          <sup>{{plan.interest_rate_type}}</sup></span>
                      </span>
                    </span>
                  </div>
                  <div class="similar" *ngIf="planInfo && planInfo.contract_type == 6">Floating Interest</div>
                </div>
                <div class="-d-block d-flex align-items-center pb-md-0 pb-2">
                  <div class="listing-body-value">Transaction Fee:</div>
                  <span *ngIf="mainService.getTransactionFee(planInfo,plan.recurring_amount)"
                    class="title-value font-15 text-colr position-relative listing-body-value font-weight-bold"> <span
                      *ngIf="mainService.promotionalTransactionOffer" class="strike_through_class fs-16 fw-600">
                      <span class="notranslate">
                        {{mainService.getTransactionFeeStrike(planInfo,plan.recurring_amount,1)}}</span></span>
                    <img *ngIf="planInfo && planInfo.contract_type == 6 && showTransactionTip"
                      src="assets\png\Icons.png" alt="" class="info_icon px-1"
                      [tooltip]="'Transaction fee will be '+ transactionFee1 +'/payment if recurring amount is lesser to $'+planInfo.threshold_amount +'.
                                  Transaction fee will be '+ transactionFee2 +'/payment if recurring amount is greater than or equal to $' +planInfo.threshold_amount + '.'">

                    <div [ngClass]="mainService.promotionalTransactionOffer ? '' : ''" class="d-inline-block ms-2">
                      <span class="text--black fs-15 fw-600">
                        <span class="notranslate">
                          {{(mainService.getTransactionFee(planInfo,plan.recurring_amount,1) == '$0' ||
                          mainService.getTransactionFee(planInfo,plan.recurring_amount,1) == '0%') ?
                          mainService.getTransactionFee(planInfo,plan.recurring_amount,1) :
                          mainService.getTransactionFee(planInfo,plan.recurring_amount,1) + '/payment'}}</span>
                      </span>
                      <div *ngIf="mainService.promotionalTransactionOffer" class="recurring-percent">
                        Promo
                      </div>
                    </div>
                  </span>
                </div>
                <div class="-d-block d-flex align-items-center pb-md-0 pb-2 "
                  *ngIf="plan && plan.advance_interest_amount">
                  <span *ngIf="planInfo && planInfo.contract_type == 1 || planInfo.contract_type == 3"
                    class="text-wrap text-start recurring-text">First Recurring Due
                    Today </span>
                  <!--  || planInfo.contract_type == 5 -->
                  <span
                    *ngIf="planInfo && planInfo.contract_type == 2 || planInfo.contract_type == 4 || planInfo.contract_type == 6 || planInfo.contract_type == 5"
                    class="similar listing-body-value">
                    {{planInfo && planInfo.is_ar_contract == 1 ? 'Upfront Payment:' :'Upfront Fee:'}}
                  </span>
                  <div class="">
                    <span class="plan_card_value fs-16 ms-2">
                      <span class="notranslate listing-body-value font-weight-bold">
                        {{mainService.currency_data.display_logo}}{{plan?.advance_interest_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <span class=" mb-0 fs-16 monthly-fixed totalpay text-sm-start-text-center">
                    <span class="
                  listing-body-value -d-block d-inline-block ">Total Payable Today:</span>
                    <span>
                      <span class="listing-body-value font-weight-bold text--black"> &nbsp;&nbsp;
                        <span translate="no">{{mainService.currency_data.display_logo}}{{
                          plan.to_pay_today|DynamicDecimalPipe:mainService.currency_data.currency_code}} </span></span>
                      <span class="info_icon_btn" *ngIf="plan.to_pay_today > 0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path
                            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                            stroke="#646C70" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.375 9.375H10V13.75H10.625" stroke="#646C70" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                            fill="#646C70" />
                        </svg>
                        <span class="color-gray-1 show_div custom_tool_recurring d-none"
                          [ngClass]="planInfo && planInfo.is_ar_contract ==1 ? 'ar_contract':'tooltip_box' ">
                          <div
                            class="d-flex justify-content-between border-bottom p-2 align-items-center ng-star-inserted">
                            <span>{{'This includes the'+ (planInfo.is_ar_contract == 1 ? '' :' Down Payment,') +
                              (plan.advance_interest_amount ?
                              (planInfo.contract_type == 1 || planInfo.contract_type == 3 ? 'First Recurring Payment, ':
                              (planInfo.is_ar_contract == 1 ? ' Upfront Payment, ' :' Upfront Fee, ')) : '') +
                              (planInfo.is_ar_contract == 1 ? '' :'Enrollment Fee,') +
                              (planInfo.is_ar_contract == 1 && planInfo.downpayment_amount > 0 ? ' Partial Payments, ' :
                              '') +
                              ' and Transaction Fee.'}}</span>
                          </div>
                        </span>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="px-3" *ngIf="creditReportOption && this.planInfo?.country_id == 1">
            <div class="credit-option" [ngClass]="{'active': this.planInfo?.plans_array && this.planInfo?.plans_array[0]?.creditReportOption}">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center" (click)="toggleCreditOption()">
                  <input type="checkbox" id="creditToggle" [checked]="this.planInfo?.plans_array && this.planInfo?.plans_array[0]?.creditReportOption"
                    class="credit-checkbox" (click)="toggleCreditOption(); $event.stopPropagation()" />
                  <span class="ms-2">Build credit with your on-time payments</span>
                </div>
              </div>
              <div class="text-start mt-2" *ngIf="planInfo?.plans_array && planInfo?.plans_array[0]?.creditReportOption"><span class="fw-600">
                      {{mainService?.currency_data?.display_logo}}
                  {{this.planInfo?.credit_report_amount | DynamicDecimalPipe:mainService?.currency_data?.currency_code}}
                    </span>
                    <span>/mo- we’ll report this plan’s payments to major credit bureaus to help build positive history. Cancel anytime.</span>
                  </div>
                  <div class="text-start mt-2" *ngIf="planInfo?.plans_array && !planInfo?.plans_array[0]?.creditReportOption"><span class="fw-600">
                      Heads up: </span>
                    <span>Turning this off means your on-time payments for this plan won’t be reported - and won’t help build credit history.
                      <span class="keepText" (click)="animationStart? '' :toggleCreditOption(i)">Keep Credit Reporting</span>
                    </span>
                  </div>
            </div>
            <!-- <div *ngIf="this.planInfo?.plans_array && !this.planInfo?.plans_array[0]?.creditReportOption">
              <p class="fw-600" style="color:#9A59FF">*What is better credit worth to you?</p>
              <p class="m-0" style="color:#9959ffee">
                Reporting your payments to the credit bureaus ensures your good payment habits are rewarded.
              </p>
            </div> -->
          </div>
        </div>
        <div class="footer-button-wrapper col-12" [class.col-md-9]="planInfo.is_ar_contract != 1">
          <span class="fixed_interest" *ngIf="!planInfo['hide_interest_rate_type_text']">
            <div class="fixed_interest_f">
              <div>
                <span>F:</span> <span>
                  Fixed Interest
                </span>
              </div>
              <div>
                <span>C:</span> <span> Compound Interest</span>
              </div>

            </div>
          </span>
          <div class="col continue-btn-wrap" [ngClass]="selected_plan_index >= 0 ? 'button_continue' : ''">

            <div class="col px-0">
              <button class="mt-sm-3 mt-0 plans-btn plan-btn-fix w-md-auto w-100"
                (click)="updatePlan(planInfo.plans_array, selected_plan_index)" button-primary-auth type="submit"
                [disabled]="!continueButton" id="Continue1">Continue</button>
            </div>
          </div>
        </div>
        <footer class="footer text-center d-none mt-3">
          <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
            <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport"
              class="footer-help--wrap--v2">
              <a class="" href="https://www.credee.com/support" target="_blank"><svg xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_8693_20253)">
                    <path
                      d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                      fill="#20A9D3" />
                  </g>
                  <defs>
                    <clipPath id="clip0_8693_20253">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg> Need Help</a>
            </span>
            <div class="w-100 small-mob mt-2 mb-3">
              <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                    src="assets/svg/logo_colored.svg"></span></span>
            </div>
          </div>
          <div class="text-big">
            <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
              <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
                In case of any additional queries, please contact your service provider
                <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
                  '+planInfo.doctor_last_name | titlecase}}</b>
                <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
                <a class="text-bold"
                  *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                  href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                  {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
                  (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
                  (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
                </a>
              </span>

            </span>
            <span class="small-mob footer-terms--date">
              &copy; {{date | date:'yyyy'}} - Credee
            </span>
          </div>
        </footer>
      </div>
      <span class="footer-help--wrap--modify"
        *ngIf="mainService.support_data && !mainService.support_data.support_mobile">
        <span class="m-0 f-s-16 small-mob color-gray fw-700">
          <a class="" style="color: #017A9F" href="https://www.credee.com/support" target="_blank"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_8693_20253)">
                <path
                  d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                  fill="#20A9D3" />
              </g>
              <defs>
                <clipPath id="clip0_8693_20253">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg> Need Help</a>
        </span>
      </span>


      <div class="button_back_insides position-absolute d-none d-md-block" *ngIf="ar == 1">
        <span>
          <span class="left-back-btn" (click)="goBack()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14 17L9.5 12.5L14 8" stroke="#646C70" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Previous Step
          </span>
        </span>
      </div>




    </div>
  </div>
  <!-- *ngIf="selected_plan_index >= 0 " -->
  <!-- footer -->
  <footer class="footer d-none d-md-block fixed-bottom mb-3">
    <div class="mb-2 text-center text-muted fs-16"
      *ngIf="mainService.support_data && mainService.support_data.support_mobile">
      Need Help? &nbsp; Call us at <span><a highlight-color
          href="tel:{{mainService.support_data.support_mobile}}">{{mainService.support_data.support_mobile}}</a></span>,
      or <span><a highlight-color href="https://www.credee.com/support" target="_blank">Click here</a></span> to Request
      a Callback.
    </div>
    <div class="d-flex justify-content-center align-items-center py-1">
      <div class="mt-2 mt-sm-0 me-2 Powered">
        <div class="w-100 small-mob text-muted">
          <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                src="assets/svg/logo_colored.svg"></span></span>
        </div>
      </div>
      <div class="text-big">
        <span *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
          <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
            In case of any additional queries, please contact your service provider
            <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
              '+planInfo.doctor_last_name | titlecase}}</b>
            <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
            <a class="text-bold"
              *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
              href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
              {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
              (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
              (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
            </a>
          </span>

        </span>

        <span class="small-mob text-muted">
          &copy; {{date | date:'yyyy'}} - Credee
        </span>
      </div>
    </div>
  </footer>

</div>
<div bsModal #confirmPaymentDetailsModal="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static'}"
  data-keyboard="false" data-backdrop="static" class="modal -fade" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md">
    <div class="modal-content overflow-hidden" style="height: 98vh !important;">
      <div class="modal-body p-0" style="overflow-x: auto;">
        <div class="row h-100 mx-0">
          <div class="col-md-12 col-sm-12 cancel-btn p-0" *ngIf="planInfo && !onlyCloseButton"
            style="position: relative;">
            <div class="w-100 col-md-12 col-sm-12 py-3">
              <span
                class="business-logo-outer-modal business-logo-outer mx-auto d-flex justify-content-center align-items-center overflow-hidden"
                *ngIf="planInfo && planInfo.doctor_image; else elseblock">
                <img [src]="planInfo.doctor_image" class="img-fluid business-logo" alt="Doctor">
              </span>
              <ng-template #elseblock>
                <app-steps class="mt-3"></app-steps>
              </ng-template>
            </div>
            <div class="w-100 col-md-12 col-sm-12 text-center py-2 ">
              <p class="m-0 fs-24 fw-900 practice-name font-weight-bolder text-black text-capitalize"
                *ngIf="planInfo && planInfo.practice_name || planInfo.doctor_first_name">
                {{(planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name + ' ' +
                planInfo.doctor_last_name) | titlecase}}
              </p>
              <p class="py-2 mb-0 mt-2 fw-700 card-body fs-14 ">{{planInfo.practice_email || planInfo.doctor_email }}
              </p>
              <p class="pb-2 mb-0 card-body fw-700 fs-14">{{planInfo && planInfo.practice_mobile ?
                (planInfo.practice_mobile |
                phoneNumber) :'N.A.'}}</p>
            </div>

            <div class="col-12 py-3 text-center">
              <span class="rounded-pill border px-3 py-2 color-gray eta_button">
                {{planInfo && planInfo.is_ar_contract == 1 ? "Total Outstanding Balance":"Estimated Payment Plan"}}
              </span>
            </div>

            <div class="col-12 text-center pt-3">
              <span class="h1 fw-900" translate="no">
                {{mainService.currency_data.display_logo}}{{planInfo && planInfo.treatment_amount ?
                ((planInfo.treatment_amount - planInfo.downpayment_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code) : '0.00'}}
              </span>
            </div>


            <div class="col-12  finance-rows text-center py-2"
              *ngIf="planInfo && (planInfo.is_ar_contract == 1 || planInfo.enrollment_enabled != 1)">
              <span class="financing-labels font-weight-bold h5 finance-values card-body">{{((planInfo &&
                planInfo.enrollment_enabled
                !=
                1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' : planInfo && planInfo.is_ar_contract == 1 ?
                'Account
                Setup Fee:' : ''}}
                <div class="f-s-22-w-800 finance-values position-relative">
                  <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                    translate="no">{{mainService.currency_data.display_logo}}</span>
                  <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                    [innerText]="mainService.strike_enrollment_fee" translate="no"></span>
                  <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' "
                    class=" d-inline-block ms-2" translate="no">
                    {{mainService.currency_data.display_logo}} {{enrollmentFee ? (enrollmentFee|DynamicDecimalPipe:mainService.currency_data.currency_code): '0'}}
                  </div>
                  <div *ngIf="mainService.promotionalEnrollmentOffer" class="transaction-fee-popup pop-up-right">Promo
                  </div>
                </div>
              </span>
            </div>
            <div class="col mt-4" *ngIf="contract_service_record">
              <div class="col-12 px-4 mx-auto">
                <ul style="list-style-type: none;" class="px-0 service_viewer no_scroll">
                  <li class="d-flex align-items-center justify-content-between py-3 px-4 service_list_item"
                    *ngFor="let service of contract_service_record">
                    <span class="color-gray fs-14">
                      {{service.service}}
                    </span>
                    <span class="fw-700 color-dblue" translate="no">
                      {{service && service.price ?
                      (service.price |
                      currency : '$') :'$0.00'}}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-12 position-relative">
              <div class="d-flex justify-content-between align-items-center p-4 iframe-body fs-14 mt-4 rounded-top"
                style="border-bottom: 1px solid lightgrey;">
                <p class="p-0 m-0"><span class="color-gray p-0 m-0 me-1">Service amount</span>
                  <span>
                    <img src="assets\png\Icons.png" alt="" class="info_icon">
                    <span class="tooltip_box color-gray-1 show_div1 custom_tool_recurring d-none"
                      style="max-height: 180px !important; overflow-y: auto;">
                      <div class="d-flex justify-content-between border-bottom p-2 align-items-center"
                        *ngFor="let service of contract_service_record">
                        <p class="color-gray p-0 m-0 fw-400 ">{{service.service}}</p>
                        <p class="color-dblue fw-700 p-0 m-0" translate="no">
                          {{mainService.currency_data.display_logo}}{{service &&
                          service.price ?
                          (service.price|DynamicDecimalPipe:mainService.currency_data.currency_code) : '0.00'}}</p>
                      </div>
                    </span>
                  </span>
                </p>
                <p class="color-dblue fw-700 p-0 m-0" translate="no">
                  {{mainService.currency_data.display_logo}}{{planInfo.treatment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</p>
              </div>

              <div class="d-flex justify-content-between align-items-center p-4 iframe-body fs-14 rounded-bottom">

                <p class="color-gray p-0 m-0"
                  *ngIf="planInfo && planInfo.is_ar_contract == 1 && planInfo.downpayment_amount > 0">Partial Payment
                </p>
                <p class="color-dblue fw-700 p-0 m-0" translate="no"
                  *ngIf="planInfo && planInfo.is_ar_contract == 1 && planInfo.downpayment_amount > 0">
                  {{mainService.currency_data.display_logo}}{{(planInfo.downpayment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code)}}</p>

                <p class="color-gray p-0 m-0" *ngIf="planInfo && planInfo.is_ar_contract == 0">Down Payment</p>
                <p class="color-dblue fw-700 p-0 m-0" translate="no" *ngIf="planInfo && planInfo.is_ar_contract == 0">
                  {{mainService.currency_data.display_logo}}{{(planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code )}}</p>

              </div>
            </div>


            <div class="w-100 px-4 mt-3">
              <button button-primary-auth class="py-4 w-100" style="max-width: unset !important;width: 100% !important;"
                (click)="confirmPaymentDetailsModal.hide()">Let's Select a Plan</button>
            </div>


            <div class="col-12 mt-2">
              <div class="w-100 text-center color-gray-light">
                <span>Powered By <span class="text-primary ms-1"><img src="assets/svg/logo_colored.svg"></span></span>
              </div>

            </div>

            <div class="col-12 mt-2 p-0 m-0" style="position: sticky;top: 93vh;">
              <p class="p-0 m-0 fs-16 fw-400 queries_class">Any queries, please contact at <span>{{planInfo &&
                  planInfo.practice_mobile ? (planInfo.practice_mobile |
                  phoneNumber) :'N.A.'}}</span></p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>